import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CsvImportService } from "projects/packcert-web/src/app/services/csv-import.service";
import { AdminService } from "../../../services/admin.service";
import { SpinnerService } from "shared-components";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";

@Component({
  selector: "app-csv-logs-registros-no-importados",
  templateUrl: "./registros-no-importados.component.html",
})
export class CsvLogsRegistrosNoImportadosComponent implements OnInit {
  public mainKeyword = "";
  public tableHeaders: Array<any> = [];
  public errors: Array<any> = [];

  private toCloseSpinner = 0;

  public showError: boolean;
  public mensajes = new Array<any>();

  @Input() csvFileName: string | null = null;
  @Input() csvTypeId: number | null = null;
  @Input() csvTypes: Array<any> = [];
  @Output() mensaje = new EventEmitter<string>();

  constructor(
    private readonly _translate: TranslateService,
    private readonly _adminService: AdminService,
    private readonly _spinnerService: SpinnerService,
    private readonly _csvImportService: CsvImportService,
    private readonly _sessionContext: SessionContextService
  ) {}

  ngOnInit(): void {
    this.getKeywordForCsvTypeId();
    this.tableHeaders = this._csvImportService.getFilterableListTitles(
      this.mainKeyword
    );

    this.getErrors();
  }
  
  private checkCloseSpinner() {
    this.toCloseSpinner -= 1;
    if (this.toCloseSpinner === 0) {
      this._spinnerService.hideSpinner();
    }
  }

  public get role() {
    return this._sessionContext.sessionUser.role;
  }
  
  /**
   * Obtener el nombre de la clave del JSON de traducciones
   */
  private getKeywordForCsvTypeId() {
    const type = this.csvTypes.find(el => el.id === this.csvTypeId);
    this.mainKeyword = type?.titlesKey;

    /* Asegurar que para OrganizacionObtentor se muestre la subtabla correcta de Entidades */
    if (
      this.mainKeyword === 'entities' &&
      this.role === 'OrganizacionObtentor'
    ) {
      this.mainKeyword = 'entitiesBreedersOrg';
    }
  }

  private getErrors() {
    const filters = {
      fileName: this.csvFileName,
      tipoImportCsvId: this.csvTypeId,
    };

    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._adminService.getCsvLogsDetail(filters).toPromise().finally(() => {
      this.checkCloseSpinner();
    }).then(
      (resp) => {
        this.errors = resp;

        /* Asegurar que para admin también se muestre la subtabla que corresponda de Entidades
        en caso de que la importación la hiciera Org. Obt. */
        if (
          this.mainKeyword === "entities" &&
          this.role === "Administrador" &&
          resp.length > 0 &&
          (resp[0].item?.hasOwnProperty("nombreEntidad") ||
            resp[0].item?.hasOwnProperty("entityName"))
        ) {
          this.mainKeyword = "entitiesBreedersOrg";
          this.tableHeaders = this._csvImportService.getFilterableListTitles(
            this.mainKeyword
          );
        }
      },
      (error) => {
        this.showError = true;
        this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
      }
    );
  }
}
